export const config = {
  cgoBaseUrl: 'https://www.videojobfairs.com/auth/login',
  vjfpBaseUrl: 'https://www.videojobfairs.com',
  vjfpNGRestAPI: 'https://7p009q1er9.execute-api.us-east-1.amazonaws.com/default',
  gaKey: 'G-4F6C2NNSL0',
  socketUrl: 'wss://hkmdtdqmo9.execute-api.us-east-1.amazonaws.com/qa/',
  enableAnalytics: false
};
